const Lightbulb = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M480-80q-34 0-57.5-23.5T399-161h162q0 34-23.5 57.5T480-80ZM318-223v-94h324v94H318Zm5-134q-66-43-104.5-107.5T180-597q0-122 89-211t211-89q122 0 211 89t89 211q0 68-38.5 132.5T637-357H323Zm22-80h270q48-32 76.5-83T720-597q0-99-70.5-169.5T480-837q-99 0-169.5 70.5T240-597q0 26 28.5 77t76.5 83Zm135 0Z" />
        </svg>
    )
}

export default Lightbulb;

